// 应用功能开关配置
// HF Space 只开放 7860 端口，SMTP 端口不可用，邮件功能默认关闭
export const APP_FEATURES = {
  emailEnabled: false, // 邮件功能开关（注册验证、忘记密码、邮箱配置）
  inviteRequired: true, // 注册是否需要邀请码
} as const;

export interface User {
  username: string;
  role: 'user' | 'vip' | 'admin';
  daily_quota: number;
  used_today: number;
  remaining: number;
  created_at: string;
  is_active: boolean;
}

export interface LoginResponse {
  success: boolean;
  api_key: string;
  username: string;
  role: string;
}

export interface VoiceDesignRequest {
  text: string;
  voice_description: string;
  cfg_value: number;
  inference_timesteps: number;
}

export interface CloneRequest {
  text: string;
  reference_audio: File;
  control_instruction?: string;
  cfg_value: number;
  inference_timesteps: number;
}

export interface UltimateCloneRequest {
  text: string;
  reference_audio: File;
  prompt_text: string;
  cfg_value: number;
  inference_timesteps: number;
}

export interface UsageRecord {
  username: string;
  endpoint: string;
  timestamp: string;
  duration_ms: number;
  success: boolean;
  error_message?: string;
}

export interface Stats {
  total_users: number;
  active_users: number;
  total_api_calls: number;
  successful_calls: number;
  failed_calls: number;
  today_calls: number;
}

export interface CreateUserRequest {
  username: string;
  password: string;
  role: string;
  daily_quota: number;
}

export interface AccessToken {
  id: number;
  token?: string;
  token_prefix: string;
  name: string;
  is_active: boolean;
  created_at: string;
  last_used_at: string | null;
}

export interface CreateAccessTokenRequest {
  name: string;
}
